/* Mentörlük Satış Sayfası — küçük yardımcılar */
(function () {
  if (window.__mlInit) return;
  window.__mlInit = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1) Görünme animasyonu */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('[data-ml-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* 2) Sayaç: 0'dan hedef rakama */
  function initCounters(root) {
    var els = (root || document).querySelectorAll('[data-ml-count]:not([data-ml-done])');
    els.forEach(function (el) {
      var target = parseInt(String(el.getAttribute('data-ml-count')).replace(/\D/g, ''), 10);
      if (!target || reduce || !('IntersectionObserver' in window)) return;
      el.setAttribute('data-ml-done', '1');
      var fmt = new Intl.NumberFormat('tr-TR');
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        var start = null, dur = 1800;
        function tick(t) {
          if (!start) start = t;
          var p = Math.min((t - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = fmt.format(Math.round(target * eased));
          if (p < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
      }, { threshold: 0.4 });
      io.observe(el);
    });
  }

  /* 3) Ekran görüntüsü büyütme */
  var dialog;
  function openLightbox(src, alt) {
    if (!dialog) {
      dialog = document.createElement('dialog');
      dialog.className = 'ml-lightbox';
      dialog.innerHTML = '<button class="ml-lightbox__close" type="button" aria-label="Kapat">&times;</button><img alt="">';
      document.body.appendChild(dialog);
      dialog.addEventListener('click', function (e) {
        if (e.target === dialog || e.target.classList.contains('ml-lightbox__close')) dialog.close();
      });
    }
    var img = dialog.querySelector('img');
    img.src = src; img.alt = alt || '';
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else window.open(src, '_blank');
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ml-zoom]');
    if (btn) { e.preventDefault(); openLightbox(btn.getAttribute('data-ml-zoom'), btn.getAttribute('data-ml-alt')); return; }

    /* 4) YouTube: tıklanınca yükle (sayfa hızlı açılsın) */
    var yt = e.target.closest('[data-ml-yt]');
    if (yt) {
      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube-nocookie.com/embed/' + yt.getAttribute('data-ml-yt') + '?autoplay=1&rel=0&playsinline=1';
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      iframe.allowFullscreen = true;
      iframe.title = yt.getAttribute('aria-label') || 'Video';
      yt.replaceWith(iframe);
    }
  });

  /* 5) Bir video oynarken diğerlerini durdur */
  document.addEventListener('play', function (e) {
    if (e.target.tagName !== 'VIDEO' || !e.target.closest('.ml')) return;
    document.querySelectorAll('.ml video').forEach(function (v) { if (v !== e.target) v.pause(); });
  }, true);

  /* 6) Yapışkan satın alma barı */
  function initSticky() {
    var bar = document.querySelector('[data-ml-sticky]');
    if (!bar) return;
    var offer = document.getElementById('paket');
    var offerVisible = false;
    if (offer && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { offerVisible = en[0].isIntersecting; update(); }).observe(offer);
    }
    function update() {
      var show = window.scrollY > 700 && !offerVisible;
      bar.classList.toggle('is-visible', show);
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }


  /* 7) Yol haritası: kaydırdıkça dolan çizgi ve yanan adımlar */
  function initRoads(root) {
    (root || document).querySelectorAll('[data-ml-road]').forEach(function (road) {
      if (road.__mlRoad) return;
      road.__mlRoad = true;
      var track = road.querySelector('.ml-road__track');
      var steps = Array.prototype.slice.call(road.querySelectorAll('.ml-step'));
      if (!track) return;
      if (reduce) {
        track.style.setProperty('--ml-p', 1);
        road.classList.add('is-done');
        return;
      }
      road.classList.add('is-anim');
      var ticking = false;
      function update() {
        ticking = false;
        var anchor = window.innerHeight * 0.62;
        var r = track.getBoundingClientRect();
        var p = (anchor - r.top) / (r.height || 1);
        p = Math.max(0, Math.min(1, p));
        track.style.setProperty('--ml-p', p.toFixed(4));
        steps.forEach(function (s) {
          var n = s.querySelector('.ml-step__num').getBoundingClientRect();
          s.classList.toggle('is-active', n.top + n.height / 2 < anchor);
        });
        road.classList.toggle('is-done', p >= 0.999);
      }
      function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      update();
    });
  }


  /* 8) Mobil kaydırmalı galeri: yana kaydırma sadece parmak belirgin şekilde yana giderse.
        Aşağı-yukarı kaydırma her zaman sayfayı kaydırır (takılma yok). */
  var mqMobile = window.matchMedia('(max-width: 749px)');
  function initSliders(root) {
    (root || document).querySelectorAll('.ml-gallery, .ml-videos').forEach(function (track) {
      if (track.__mlSlider) return;
      var items = Array.prototype.slice.call(track.children);
      if (items.length < 2) return;
      track.__mlSlider = true;

      var viewport = document.createElement('div');
      viewport.className = 'ml-slider';
      track.parentNode.insertBefore(viewport, track);
      viewport.appendChild(track);

      var nav = document.createElement('div');
      nav.className = 'ml-slider__nav';
      var prev = document.createElement('button');
      prev.type = 'button'; prev.className = 'ml-slider__arrow'; prev.setAttribute('aria-label', 'Önceki');
      prev.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 6l-6 6 6 6"/></svg>';
      var next = prev.cloneNode(true);
      next.setAttribute('aria-label', 'Sonraki');
      next.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>';
      var dotsWrap = document.createElement('div');
      dotsWrap.className = 'ml-slider__dots';
      var dots = items.map(function (_, i) {
        var d = document.createElement('button');
        d.type = 'button'; d.className = 'ml-slider__dot'; d.setAttribute('aria-label', (i + 1) + '. öğeye git');
        d.addEventListener('click', function () { go(i); });
        dotsWrap.appendChild(d);
        return d;
      });
      nav.appendChild(prev); nav.appendChild(dotsWrap); nav.appendChild(next);
      viewport.parentNode.insertBefore(nav, viewport.nextSibling);

      var index = 0, offset = 0;
      function maxOffset() {
        var last = items[items.length - 1];
        var pad = parseFloat(getComputedStyle(track).paddingRight) || 0;
        return Math.max(0, last.offsetLeft + last.offsetWidth + pad - viewport.clientWidth);
      }
      function offsetFor(i) {
        var it = items[i];
        var o = it.offsetLeft + it.offsetWidth / 2 - viewport.clientWidth / 2;
        return Math.max(0, Math.min(maxOffset(), o));
      }
      function setX(x, animate) {
        track.style.transition = animate ? '' : 'none';
        track.style.transform = 'translate3d(' + (-x) + 'px,0,0)';
      }
      function go(i) {
        index = Math.max(0, Math.min(items.length - 1, i));
        if (!mqMobile.matches) { track.style.transform = ''; return; }
        offset = offsetFor(index);
        setX(offset, true);
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === index); d.setAttribute('aria-current', k === index ? 'true' : 'false'); });
        prev.disabled = index === 0;
        next.disabled = index === items.length - 1;
        track.querySelectorAll('video').forEach(function (v) { if (!items[index].contains(v)) v.pause(); });
      }
      prev.addEventListener('click', function () { go(index - 1); });
      next.addEventListener('click', function () { go(index + 1); });

      /* Dokunma / sürükleme */
      var sx = 0, sy = 0, dx = 0, axis = null, active = false, dragged = false, t0 = 0;
      viewport.addEventListener('pointerdown', function (e) {
        if (!mqMobile.matches || (e.pointerType === 'mouse' && e.button !== 0)) return;
        var v = e.target.closest('video');
        if (v && !v.paused) return; /* oynayan videonun çubuğunu sürüklerken kaydırma */
        active = true; axis = null; dragged = false; dx = 0;
        sx = e.clientX; sy = e.clientY; t0 = Date.now();
      });
      viewport.addEventListener('pointermove', function (e) {
        if (!active) return;
        var mx = e.clientX - sx, my = e.clientY - sy;
        if (!axis) {
          if (Math.abs(mx) < 8 && Math.abs(my) < 8) return;
          axis = Math.abs(mx) > Math.abs(my) * 1.3 ? 'x' : 'y';
          if (axis === 'y') { active = false; return; }
          try { viewport.setPointerCapture(e.pointerId); } catch (err) {}
        }
        dx = mx; dragged = true;
        var x = offset - dx;
        var max = maxOffset();
        if (x < 0) x = x / 3; else if (x > max) x = max + (x - max) / 3;
        setX(x, false);
      });
      function end() {
        if (!active) return;
        active = false;
        if (axis !== 'x') return;
        var fast = Math.abs(dx) / Math.max(1, Date.now() - t0) > 0.4;
        if (dx < -50 || (fast && dx < -15)) go(index + 1);
        else if (dx > 50 || (fast && dx > 15)) go(index - 1);
        else go(index);
      }
      viewport.addEventListener('pointerup', end);
      viewport.addEventListener('pointercancel', function () { if (axis === 'x') { active = true; dx = 0; end(); } active = false; });
      viewport.addEventListener('click', function (e) {
        if (dragged) { e.preventDefault(); e.stopPropagation(); dragged = false; }
      }, true);
      viewport.addEventListener('dragstart', function (e) { e.preventDefault(); });

      window.addEventListener('resize', function () { go(index); });
      if (mqMobile.addEventListener) mqMobile.addEventListener('change', function () { go(index); });
      go(0);
    });
  }


  function initAll(root) { initReveal(root); initCounters(root); initRoads(root); initSliders(root); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); initSticky(); });
  } else { initAll(); initSticky(); }

  /* Tema düzenleyicide bölüm değişince yeniden başlat */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); initSticky(); });
})();
